import { __decorate } from "tslib";
import { observable } from '@microsoft/fast-element';
/**
 * Represents the current user (i.e. the user that is currently logged in).
 * @public
 */
export class CurrentUser {
    constructor(options) {
        Object.assign(this, options);
    }
    hasAdminProfile() {
        return this.hasProfile('ADMIN');
    }
    hasPermission(permission) {
        return this.hasKey(this.permissions, permission);
    }
    hasProfile(profile) {
        return this.hasKey(this.profiles, profile);
    }
    /**
     * Checks if the given key or keys are present in the given array of keys.
     * @internal
     * @param keys - The array of keys to check.
     * @param key - The key or keys to check for.
     * @returns True if the key or keys are present in the array of keys.
     */
    hasKey(keys, key) {
        if (!keys || !keys.length || !key) {
            return false;
        }
        if (!Array.isArray(key)) {
            key = [key];
        }
        return key.some((k) => keys.includes(k));
    }
}
__decorate([
    observable
], CurrentUser.prototype, "permissions", void 0);
__decorate([
    observable
], CurrentUser.prototype, "profiles", void 0);
__decorate([
    observable
], CurrentUser.prototype, "username", void 0);
